/**
 * 本地自然日工具（决策 14.6 / ADR-010）。
 * 训练归属日、每日意图 unique 键、饮食归属都按「用户本地自然日」判断。
 * 这里只做展示与「当前本地日期」；跨设备判重由后端/仓储负责。
 */
export function localDateString(
  tsMs: number = Date.now(),
  timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone,
): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date(tsMs));
  const y = parts.find((p) => p.type === "year")?.value ?? "";
  const m = parts.find((p) => p.type === "month")?.value ?? "";
  const d = parts.find((p) => p.type === "day")?.value ?? "";
  return `${y}-${m}-${d}`;
}

/** 当前用户时区 IANA 名，例如 Asia/Shanghai。 */
export function currentTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
